/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Digest_SessionInputs */

const en_portal_remind_digest_session = /** @type {(inputs: Portal_Remind_Digest_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18:00 · 1:1 session with Kasia`)
};

const pl_portal_remind_digest_session = /** @type {(inputs: Portal_Remind_Digest_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`18:00 · Trening 1:1 z Kasią`)
};

/**
* | output |
* | --- |
* | "18:00 · 1:1 session with Kasia" |
*
* @param {Portal_Remind_Digest_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_digest_session = /** @type {((inputs?: Portal_Remind_Digest_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Digest_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_digest_session(inputs)
	return en_portal_remind_digest_session(inputs)
});